import { NavigationEnd, Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { filter } from 'rxjs/operators';

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

@Injectable({ providedIn: 'root' })
export class MetaPixelService {
  private router = inject(Router);

  private initialized = false;
  private pixelId?: string;

  init(pixelId: string) {
    if (!pixelId || !/^\d{8,20}$/.test(pixelId)) return; // validate
    // P0 (data protection): honor Do Not Track — this flow carries minors' PII
    // in the URL/referrer. If DNT is on, don't load the third-party tracker.
    if (this.doNotTrackEnabled()) return;
    this.pixelId = pixelId;

    // Avoid double init
    if (this.initialized) return;

    this.bootstrapFbq();
    this.loadScriptOnce('https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');

    // SPA route tracking
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => {
        if (window.fbq) window.fbq('track', 'PageView');
      });

    this.initialized = true;
  }

  private doNotTrackEnabled(): boolean {
    const nav = window.navigator as any;
    const dnt =
      nav.doNotTrack || (window as any).doNotTrack || nav.msDoNotTrack;
    return dnt === '1' || dnt === 'yes' || dnt === true;
  }

  private bootstrapFbq() {
    if (window.fbq) return;

    const fbq = function (...args: any[]) {
      // queue until script loads
      if ((fbq as any).callMethod) {
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        (fbq as any).queue.push(args);
      }
    } as any;

    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';

    window.fbq = fbq;
    window._fbq = fbq;
  }

  private loadScriptOnce(src: string) {
    if (document.querySelector(`script[src="${src}"]`)) return;
    const s = document.createElement('script');
    s.async = true;
    s.src = src;
    document.head.appendChild(s);
  }
}
